import React, { useState, useEffect, useRef } from "react";
import "./vitalsView.scss";
import Grid from "@material-ui/core/Grid";
import VitalComponent from "../../../common/VitalComponent";
import arrow_icon from "../../../../assets/down-arrow-black.svg";
import scroll from "../../../../assets/expandless.svg";
import expandlessSmall from "../../../../assets/expandlesssmall.svg";
import { GET_PAST_VITALS } from "../../ERXViewApiHandler/apiConstants";
import { VITALS_LIST } from "../../ERXConstants/constants";
import moment from "moment";
import useDebounce from "../../common/debounce";
import VitalDatePickerInput from "../../../common/VitalDatePickerInput";
import { c2cGetApiHandler } from "../../../../Util/c2cApiHandler";

const VitalsView = (props) => {
  const {
    element,
    vitalsList,
    pastVitalsSetting,
    setVitalsList,
    setEditedPayload,
    editedPayload,
    saveVitals,
    addEditVitals,
    setAddEditVitals,
  } = props;

  const refsArray = useRef([]);

  const [pastvitals, setpastVitals] = useState([]);
  const [showPastVitals, setshowPastVitals] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [maxApiCall, setMaxApiCall] = useState(0);
  const [cancel, setCancel] = useState(false);
  const debounceForAddEditVitals = useDebounce(addEditVitals, 500, cancel);
  const [prevSelectedVital, setPrevSelectedVital] = useState(1);

  // ----------LIFE CYCLE ------------- //;

  useEffect(() => {
    if (debounceForAddEditVitals?.call_api) {
      saveVitals();
    }
  }, [debounceForAddEditVitals]);

  useEffect(() => {
    fetchPastVitals();
  }, [pageNo]);

  // ----------------------------- //

  // ------------PAST VITALS--------------//
  const fetchPastVitals = () => {
    let params = {
      appointment_id: props?.appointmentData?.appointment_id,
      page_no: pageNo,
    };
    c2cGetApiHandler(GET_PAST_VITALS, params).then(([res, error]) => {
      if (!error) {
        let newData = res?.data?.data ?? [];
        setpastVitals([...pastvitals, ...newData]);
        setTotalRecords(res?.data?.total_count);
        let limit = res?.data?.total_count / 5;
        setMaxApiCall(limit);
      }
    });
  };

  const formatKey = (key) => {
    return key.replaceAll("_", " ").replace(/\w+/g, function (w) {
      return w[0].toUpperCase() + w.slice(1).toLowerCase();
    });
  };

  const renderValueUnit = (ob, isMobile, inx) => {
    let fields = VITALS_LIST.map((obj) => {
      return obj.name.toLowerCase().replace(" ", "_");
    });
    if (props?.updatedGender !== "Female" && props?.updatedGender !== "Others")
      fields.pop("lmp"); // hide lmp field if male

    let unitValue = (key, ob, inx, ind) => {
      return (
        <div
          key={ind}
          className={`${isMobile ? "col-4" : "" + " my-2 mx-1"}`}
          style={{
            textAlign: "left",
            overflowWrap: window.innerWidth < 768 ? "break-word" : "normal",
            paddingRight: "15px",
          }}
        >
          <div
            className="vitals-past-visit-table-key my-1 mb-2"
            style={{
              whiteSpace: window.innerWidth < 768 ? "noraml" : "nowrap",
              overflowWrap: window.innerWidth < 768 ? "break-word" : "normal",
            }}
          >
            <p className="mb-0">{formatKey(key)}</p>
          </div>
          <div
            className="vitals-past-visit-table-value mt-1"
            ref={(el) => (refsArray.current[inx] = el)}
          >
            <p className="mb-0">
              {key === "bmi" ? ob[key]?.toFixed(2) : ob[key] ?? " "}
              &nbsp;
              {ob[key] !== null && ob[`${key}_unit`]}
            </p>
          </div>
        </div>
      );
    };

    let newArranged = {
      weight: ob?.weight,
      height: ob?.height,
      bmi: ob?.bmi,
      bp_systolic: ob?.bp_systolic,
      bp_diastolic: ob?.bp_diastolic,
      respiration_rate: ob?.respiration_rate,
      spo2: ob?.spo2,
      pulse_rate: ob?.pulse_rate,
      temperature: ob?.temperature,
      random_glucose: ob?.random_glucose,
      lmp: ob?.lmp,
    };

    return Object.keys(newArranged).map((key, ind) => {
      if (fields.includes(key)) {
        return unitValue(key, ob, inx, ind);
      }
    });
  };

  const showPastVisitVitals = () => {
    return (
      <>
        <div className="w-100 d-flex justify-content-between">
          <div>
            <p className="mb-1"> Vitals from past Visit's</p>
          </div>
          <div>
            <img
              className={
                showPastVitals
                  ? "vitals-past-visit-up-arrow"
                  : "vitals-past-visit-down-arrow"
              }
              src={arrow_icon}
              style={{ height: "15px", width: "15px" }}
              onClick={() => setshowPastVitals(!showPastVitals)}
              alt=""
            ></img>
          </div>
        </div>
        {showPastVitals ? (
          <div
            className="vitals-past-visit w-100"
            onScroll={(e) => {
              let bottom =
                e.target.scrollHeight - Math.round(e.target.scrollTop) ===
                e.target.clientHeight;
              if (
                e.target.scrollHeight - Math.round(e.target.scrollTop) + 1 ===
                e.target.clientHeight
              ) {
                bottom = true;
              }
              if (
                e.target.scrollHeight - Math.round(e.target.scrollTop) - 1 ===
                e.target.clientHeight
              ) {
                bottom = true;
              }

              if (bottom) {
                if (pageNo < maxApiCall && pageNo !== 0) {
                  setPageNo(pageNo + 1);
                } else if (pageNo === 0) {
                  setPageNo(1);
                }
              }
            }}
          >
            <Grid item="true">
              {pastvitals?.length > 0 &&
                pastvitals?.map((ob, inx) => {
                  return (
                    <div className="vitals-past-visit-container " key={inx}>
                      <div className="vitals-past-visit-date ml-1">
                        {moment(ob?.created_at).format("DD MMMM YYYY")}
                      </div>
                      <div className="vitals-past-visit-table d-flex">
                        {window.innerWidth < 768 && (
                          <Grid container direction="row">
                            {renderValueUnit(ob, true, inx + 1)}
                          </Grid>
                        )}
                        {window.innerWidth > 768 && (
                          <div className="d-flex">
                            {renderValueUnit(ob, false, inx + 1)}
                          </div>
                        )}
                      </div>
                      {window.innerWidth > 768 && (
                        <div
                          className="vitals-past-visit-table-horizontal-scroll"
                          onClick={() => {
                            let id = refsArray.current[inx + 1];
                            if (id) {
                              id.scrollIntoView({
                                behavior: "smooth",
                                block: "nearest",
                                inline: "start",
                              });
                            }
                          }}
                        >
                          <img
                            src={scroll}
                            style={{ height: "10px", width: "10px" }}
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
            </Grid>
          </div>
        ) : null}
      </>
    );
  };

  const getBMI = (vitalsListItem, index, e) => {
    let weight;
    let height;
    let val = e ? e.target.value : vitalsListItem[index].value;
    if (index === 0) {
      height =
        vitalsListItem[1].unit === "ft’in”"
          ? vitalsListItem[1].value * 0.3048
          : vitalsListItem[1].value / 100;
      weight = vitalsListItem[0].unit === "Lbs" ? val * 0.453592 : val;
    }
    if (index === 1) {
      weight =
        vitalsListItem[0].unit === "Lbs"
          ? vitalsListItem[0].value * 0.453592
          : vitalsListItem[0].value;
      height = vitalsListItem[1].unit === "ft’in”" ? val * 0.3048 : val / 100;
    }

    let bmi = weight / Math.pow(height, 2);
    return parseFloat(bmi);
  };

  const handleVitalChange = (e, item) => {
    if (prevSelectedVital !== item.id) {
      setCancel(true);
    } else {
      setCancel(false);
    }
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    if (item.id === 1 || item.id === 2) {
      let bmi = getBMI(vitalsList, index, e);
      vitalsList[2].value = bmi?.toFixed(2); // 2 is BMI id
    }
    vitalsList[index].value = e.target.value;
    let payload = {};
    vitalsList.forEach((obj) => {
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] = obj.value;
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] = obj.unit;
    });
    setEditedPayload({ ...editedPayload, ...payload });
    setAddEditVitals({
      call_api: true,
      value: { ...editedPayload, ...payload },
    });
    setVitalsList([...vitalsList]);
    setPrevSelectedVital(item.id);
  };

  const onArrowClick = (item) => {
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    let ind = vitalsList[index].unitList.findIndex(
      (un) => un === vitalsList[index].unit
    );
    if (vitalsList[index].unitList[ind + 1]) {
      vitalsList[index].unit = vitalsList[index].unitList[ind + 1];
    } else {
      vitalsList[index].unit = vitalsList[index].unitList[0];
    }
    if (item.id === 1 || item.id === 2) {
      let bmi = getBMI(vitalsList, index);
      vitalsList[2].value = bmi?.toFixed(2); // 2 is BMI id
    }
    let payload = {};
    vitalsList.forEach((obj) => {
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] = obj.value;
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] = obj.unit;
    });
    setEditedPayload({ ...editedPayload, ...payload });
    setAddEditVitals({
      call_api: true,
      value: { ...editedPayload, ...payload },
    });
    setVitalsList([...vitalsList]);
  };

  const handleDateChange = (date, item) => {
    if (prevSelectedVital !== item.id) {
      setCancel(true);
    } else {
      setCancel(false);
    }
    let index = vitalsList.findIndex((vi) => vi.id === item.id);
    let dateOne = moment().format("YYYY-MM-DD");
    let dateTwo = moment(date).format("YYYY-MM-DD");
    vitalsList[index].value = date
      ? Math.abs(moment(dateOne).diff(dateTwo, "days")) + ""
      : "";
    let payload = {};
    vitalsList.forEach((obj) => {
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] = obj.value;
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] = obj.unit;
    });
    setEditedPayload({ ...editedPayload, ...payload });
    setAddEditVitals({
      call_api: true,
      value: { ...editedPayload, ...payload },
    });
    setVitalsList([...vitalsList]);
    setPrevSelectedVital(item.id);
  };

  const showVitalInputs = () => {
    let slicedData = vitalsList?.slice(0, 6);
    if (showMore) {
      slicedData =
        props?.updatedGender === "Male" || props?.updatedGender === "Others"
          ? vitalsList.filter((obj) => obj.name !== "LMP")
          : vitalsList;
    }
    const enableDisable = (list, vita) => {
      let dis = false;
      if (vita.name === "BMI") {
        let fil = list?.filter(
          (obj) => obj["name"] === "Height" || obj["name"] === "Weight"
        );
        let filtered = fil?.forEach((o) => {
          if (o.value === "") {
            dis = true;
          }
        });
        return dis;
      }
    };
    return (
      <Grid container spacing={2}>
        {slicedData?.map((vital, ind) => {
          return (
            <Grid item="true" md={3} xs={12} key={ind}>
              <div
                className={
                  enableDisable(vitalsList, vital)
                    ? "vitals-inputs-disable-bmi"
                    : "" + vital.name === "Random Glucose"
                    ? "pad-unit"
                    : ""
                }
                id={element.name}
              >
                <p className="m-0 pb-1">{vital.name}</p>
                {vital?.name === "LMP" ? (
                  <div className="vitals-lmp-input">
                    <VitalDatePickerInput
                      differentInputFormat={
                        !isNaN(parseInt(vital?.value))
                          ? vital?.value + " Days"
                          : ""
                      }
                      selected_date={""}
                      maxDate={new Date()}
                      allowBackspace={true}
                      handleDateChange={(date) => handleDateChange(date, vital)}
                    />
                  </div>
                ) : (
                  <VitalComponent
                    item={vital}
                    placeholder={""}
                    value={vital.value}
                    selectedUnit={vital.unit}
                    disabled={vital.name === "BMI" ? true : false}
                    unitList={vital.unitList}
                    allowDecimal={true}
                    handleUpArrowClick={(item) => onArrowClick(item)}
                    handleDownArrowClick={(item) => onArrowClick(item)}
                    handleOnChange={(e, item) => handleVitalChange(e, item)}
                  />
                )}
              </div>
            </Grid>
          );
        })}
        <div className="w-100" onClick={() => setShowMore(!showMore)}>
          <div className="float-right">
            <button className="vitals-inputs-showmore">
              {!showMore ? "Show More" : "Show Less"}
            </button>
            <img
              className={
                showMore
                  ? "vitals-past-visit-down-arrow"
                  : "vitals-past-visit-up-arrow"
              }
              src={expandlessSmall}
              style={{ height: "15px", width: "15px" }}
              alt=""
            ></img>
          </div>
        </div>
      </Grid>
    );
  };

  // -------------------------- //
  const renderVitalsSection = () => {
    return (
      <div className="p-1">
        <div className="vitals-inputs">{showVitalInputs()}</div>
        {pastvitals?.length > 0 && pastVitalsSetting && (
          <div>
            <hr style={{ marginRight: "-15px", marginLeft: "-15px" }}></hr>
            {showPastVisitVitals()}
          </div>
        )}
      </div>
    );
  };
  return <>{renderVitalsSection()}</>;
};
export default VitalsView;
